import PropTypes from 'prop-types'
import React from 'react'
import {colors, text} from '../styles'
import {css} from 'glamor'

const style = {
  badge: css(text.badge, {
    border: '1px solid',
    borderRadius: '3px',
    display: 'inline-block',
    padding: '6px 12px',
    textAlign: 'center'
  }),
  default: css({
    color: colors.white,
    backgroundColor: colors.grayLight
  }),
  success: css({
    color: colors.white,
    backgroundColor: colors.green1
  }),
  important: css({
    color: colors.white,
    backgroundColor: colors.activeBG
  })
}

const Badge = ({children, kind, style: customStyle}) => {
  let elementStyle = style.badge

  // Deal with legacy classnames in the API responses.
  kind = kind.replace('label-', '')

  switch (kind) {
    case 'success':
      elementStyle = css(elementStyle, style.success)
      break

    case 'important':
    case 'warning':
      elementStyle = css(elementStyle, style.important)
      break

    case 'default':
    default:
      elementStyle = css(elementStyle, style.default)
      break
  }

  elementStyle = css(elementStyle, customStyle)

  return <div {...elementStyle}>{children}</div>
}

Badge.propTypes = {
  children: PropTypes.node,
  kind: PropTypes.oneOf([
    'label-default',
    'label-success',
    'label-important',
    'label-info',
    'label-inverse',
    'label-warning',
    'default',
    'success',
    'important',
    'info',
    'inverse',
    'warning'
  ]),
  style: PropTypes.object
}

Badge.defaultProps = {
  kind: 'default'
}

export default Badge
